import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { loadNamatAssessment } from '@/lib/firebase/queries/namatAssessment';
import { SCORE_UPDATE_EVENT } from './score-events';

export function ScoreBadge() {
  // The beneficiary's valid Namat scale percentage (spec #86); hidden when
  // the questionnaire is not done or has expired.
  const [percent, setPercent] = useState<number | null>(null);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    const refresh = async () => {
      try {
        const a = await loadNamatAssessment(user.uid);
        if (!cancelled) setPercent(a.status === 'valid' && a.scale ? a.scale.percent : null);
      } catch (error) {
        console.error('Error loading the Namat scale:', error);
      }
    };
    refresh();
    // A just-saved questionnaire: re-read once the write has landed.
    const onScoreUpdate = () => setTimeout(refresh, 1000);
    window.addEventListener(SCORE_UPDATE_EVENT, onScoreUpdate);
    return () => {
      cancelled = true;
      window.removeEventListener(SCORE_UPDATE_EVENT, onScoreUpdate);
    };
  }, [user]);

  if (percent === null) return null;

  return (
    <div className="pointer-events-none absolute -bottom-1 -right-1 bg-foreground text-white text-xs font-medium rounded-full border-2 border-white px-2 py-1">
      {percent}%
    </div>
  );
}
